<div
  *ngIf="((isLoading | async) && !preventAutoBlocking) || showLoader"
  class="overlay"
>
  <div class="loader-background"><div class="loader-bar"></div></div>
</div>
